import React from 'react'
import classnames from 'classnames'

import './styles.scss'

const ButtonSelector = ({ options, value, onChange }) => {
  return (
    <div className="button-tabs__container">
      {options.map((type) => (
        <button
          key={type.value}
          className={classnames('button-tabs', {
            'button-tabs--active': type.value === value,
          })}
          value={type.value}
          onClick={(event) => onChange(event, type.value)}
        >
          {type.label}
        </button>
      ))}
    </div>
  )
}

export default ButtonSelector
